import React from "react";
import { CustomerRootScreenActionsContext } from "./context";

export const useCustomerRootScreenActionsContextProvider = () => {
  const context = React.useContext(CustomerRootScreenActionsContext);
  return context;
};
